module.exports = __webpack_public_path__ + "img/589.5fd87949.jpg";